/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit3_TInputs */

const en_formatter_pit3_t = /** @type {(inputs: Formatter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not use formatting to canonicalize for signature checks`)
};

const ko_formatter_pit3_t = /** @type {(inputs: Formatter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서명 검증용 정규형을 만드는 데 포매팅을 쓰지 마세요`)
};

const ja_formatter_pit3_t = /** @type {(inputs: Formatter_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名検証用の正規形を作るのに整形を使わないでください`)
};

/**
* | output |
* | --- |
* | "Do not use formatting to canonicalize for signature checks" |
*
* @param {Formatter_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit3_t = /** @type {((inputs?: Formatter_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit3_t(inputs)
	if (locale === "ko") return ko_formatter_pit3_t(inputs)
	return ja_formatter_pit3_t(inputs)
});